import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useDealRequestEmailNotifications } from 'hooks/useDealRequestEmailNotifications';
import { showErrorMessage } from 'helpers/notifications';

import styles from './styles.module.scss';

interface DealEmailNotificationsProps {
  /** Load the setting only when the panel holding the toggle is visible */
  isActive: boolean;
}

export default function DealEmailNotifications({ isActive }: DealEmailNotificationsProps) {
  const { t } = useTranslation();
  const { isEnabled, isLoading, isSaving, toggle } = useDealRequestEmailNotifications(isActive);

  const handleChange = () => {
    toggle().catch(() => showErrorMessage(t('dialog.dealEmailNotificationsError')));
  };

  return (
    <label className={cn(styles.row, !isEnabled && styles['row--off'])} title={t('dialog.dealEmailNotificationsHint')}>
      <span className={styles.label}>{t('dialog.dealEmailNotifications')}</span>
      <input
        type="checkbox"
        className={styles.input}
        checked={isEnabled}
        onChange={handleChange}
        disabled={isLoading || isSaving}
      />
      <span className={styles.switch} />
    </label>
  );
}
